export default __webpack_public_path__ + "static/media/banner-home-mobile.016acbc3.webp";